import React from 'react';
import CardBody from "./card-body.jsx";
import CardHeader from "./card-header.jsx";
import CardTitle from "./card-title.jsx";
import CardFooter from "./card-footer.jsx";

const _Card = ({children, className, reference, id, hidden, notShowInPrint = true, onClick}) => {
    return (
        <div id={id} className={[`bg-white rounded-[0.5rem] shadow-none border border-[#ededed] 
        ${notShowInPrint ? "print:!border-0 print:!border-none print:shadow-none" : ""} relative`, className].join(" ")} ref={reference} hidden={hidden} onClick={onClick}>
            {children}
        </div>
    );
};

export const Card = Object.assign(_Card, {
    Header: CardHeader,
    Title: CardTitle,
    Body: CardBody,
    Footer: CardFooter
});